module.exports = __webpack_public_path__ + "img/categories_memoire_mobile_all@2x.f85ca08.webp";